module.exports = __webpack_public_path__ + "img/icon_checked.cda8e916.png";